import { createContext, useContext } from 'react';

const RealNavigationTypeContext = createContext('PUSH');

export const RealNavigationTypeProvider = RealNavigationTypeContext.Provider;

export const useRealNavigationType = () => useContext(RealNavigationTypeContext);
